import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function TermsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="w-full px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto">
            <button
              onClick={() => navigate('/')}
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-primary-500 mb-6 transition-colors"
            >
              <i className="ri-arrow-left-line" />
              {t('back_to_home')}
            </button>

            <h1 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-950 mb-6">
              Terms of Use
            </h1>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-6">
              <p>
                By accessing and using this website, you agree to be bound by the following terms and conditions. If you do not agree with any part of these terms, please do not use this website.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Use of Website</h2>
              <p>
                This website is provided for informational purposes only. You may use the content for personal, non-commercial research and reference. You may not reproduce, distribute, modify, or create derivative works from our content without prior written permission.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">No Commercial Transactions</h2>
              <p>
                We do not sell products, process payments, or handle shipping. All external links lead to third-party websites where actual transactions take place. We are not responsible for any transactions, disputes, or issues that arise on external websites.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">External Links</h2>
              <p>
                This website contains links to external websites for your convenience. We do not endorse, control, or take responsibility for the content, privacy policies, or practices of any third-party websites. Visiting external links is at your own risk.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Information Accuracy</h2>
              <p>
                While we strive to provide accurate and up-to-date information, we make no warranties or representations about the accuracy, completeness, or reliability of any content on this website. Product information, prices, shipping costs, and other details may change without notice. Always verify information on the official platform before making decisions.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of this website or reliance on any information provided. This includes but is not limited to losses related to purchasing decisions, shipping issues, customs problems, or product quality disputes.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Intellectual Property</h2>
              <p>
                All content on this website, including text, images, graphics, and logos, is protected by intellectual property laws. The CSSBuy name and logo are trademarks of their respective owners. Our use of these references is for informational and descriptive purposes only.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on this page. Your continued use of the website after changes constitutes acceptance of the updated terms.
              </p>

              <h2 className="text-xl font-heading font-semibold text-foreground-950 mt-8">Governing Law</h2>
              <p>
                These terms shall be governed by and construed in accordance with applicable laws. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the competent courts.
              </p>

              <p className="text-sm text-foreground-500 mt-8">
                Last updated: August 27, 2026
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}